import { render, staticRenderFns } from "./GalleryRenderer.vue?vue&type=template&id=71236679&"
import script from "./GalleryRenderer.vue?vue&type=script&lang=js&"
export * from "./GalleryRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports